export const SURVEY_TYPES = {
  RESIDENT_EVALUATION_SURVEY: 'ResidentEvaluationSurvey',
  CYCLE_EVALUATION_SURVEY: 'CycleEvaluationSurvey',
  MANAGER_EVALUATION_SURVEY: 'ManagerEvaluationSurvey',
  CLINICAL_CASE_SURVEY: 'ClinicalCaseSurvey',
  TECHNICAL_SKILL_SURVEY: 'TechnicalSkillSurvey',
  SURVEY_360: 'Survey360'
};
